import { useCallback, useEffect, useState } from 'react';
import {
  Container, Grid, Card, Typography,
  CardActionArea, Dialog, DialogTitle, DialogContent
} from '@mui/material';

import { getAllOrdini } from '../APIs/OrdersAPI';
import ModalDettaglioComanda from './ModalDettaglioComanda';
import SidebarLayout from '../components/sidebarLayout';
import { useTranslation } from 'react-i18next';
import { SetupWSEventListener } from '../utils/setupWSEventListener';
import { useSnackbar } from '../contexts/SnackBarContext';

function ListaOrdini() {
  const [comande, setComande] = useState([]);
  const [selectedComanda, setSelectedComanda] = useState(null);
  const {t} = useTranslation();
  const { showSnackbar } = useSnackbar();

  const token = localStorage.getItem('accessToken');
  const tenant = localStorage.getItem('tenantId');

  const fetchOrdiniUnificati = useCallback(async () => {
    try {
      const ordini = await getAllOrdini(token, tenant, { noCache: true });

      const ordiniPerTavolo = {};

      ordini.forEach((ordine) => {
        if (ordine.status !== 'OPEN') return;

        const tableId = ordine.tableId;

        if (!ordiniPerTavolo[tableId]) {
          ordiniPerTavolo[tableId] = {
            ...ordine,
            orderProducts: [...(ordine.orderProducts || [])]
          };
        } else {
          ordiniPerTavolo[tableId].orderProducts.push(...(ordine.orderProducts || []));
        }
      });

      setComande(Object.values(ordiniPerTavolo));
    } catch (error) {
      handleAlert(error.message, "error")
    }
  }, []);

  useEffect(() => {
    fetchOrdiniUnificati();
    const handler = () => {
      fetchOrdiniUnificati();
    };
    window.addEventListener('comanda-creata', handler);

    const cleanup = SetupWSEventListener(fetchOrdiniUnificati);

    return () => {
      window.removeEventListener('comanda-creata', handler);
      cleanup();
    };
  }, [fetchOrdiniUnificati]);

  const calcolaTotale = (comanda) => {
    if (!Array.isArray(comanda?.orderProducts)) return 0;
    return comanda.orderProducts.reduce((tot, p) => {
      return tot + ((p.product?.price || 0) * p.quantity);
    }, 0);
  };

  function handleAlert(msg, type) {
    showSnackbar(msg, type)
  }

  return (
    <SidebarLayout>
      <Container sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>{t('orders')}</Typography>
        {/* <Typography variant="h5" gutterBottom>{t("orderList")}</Typography> */}
        <Grid container spacing={2}>
          {comande.map((comanda) => (
            <Grid item xs={12} sm={6} md={4} key={comanda.id}>
              <Card>
                <CardActionArea onClick={() => setSelectedComanda(comanda)}>
                  <Typography variant="h6" sx={{ p: 2 }}>
                    {t("booking.table")}: {comanda.table?.name || `ID ${comanda.tableId}`}
                  </Typography>
                  <Typography variant="body1" sx={{ px: 2, pb: 2 }}>
                    {t("total")}: {calcolaTotale(comanda).toFixed(2)}€
                  </Typography>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Dialog open={Boolean(selectedComanda)} onClose={() => setSelectedComanda(null)} fullWidth maxWidth="sm">
          <DialogTitle>{t("orderDetails")}</DialogTitle>
          <DialogContent>
            {selectedComanda && (
              <ModalDettaglioComanda
                comanda={selectedComanda}
                onClose={() => setSelectedComanda(null)}
              />
            )}
          </DialogContent>
        </Dialog>
      </Container>
    </SidebarLayout>
  );
}

export default ListaOrdini;
